import { useIntl } from "react-intl";

const DataResidency = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.DataResidency.header",
            defaultMessage: "Data residency"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.DataResidency.body",
            defaultMessage:
                "With data residency management, choose where key product data at rest is hosted within Atlassian’s global cloud footprint."
        }),
        body2: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.DataResidency.body2",
            defaultMessage:
                "You can pin a cloud instance's data to a specific geographic realm (for example, US or EU). This gives your administrators more control, which is useful when they require more flexibility and visibility into how their organization's content is stored."
        }),
        link: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.DataResidency.link",
                defaultMessage:
                    "<learnMore>Learn more</learnMore> about data residency management."
            },
            {
                learnMore: (chunk: React.ReactNode) => (
                    <a
                        href="https://confluence.atlassian.com/display/Cloud/Manage+data+residency"
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
            <p>{messages.body2}</p>
            <p>{messages.link}</p>
        </>
    );
};

export default DataResidency;
